/**
 * Маппер для преобразования строки wishlist_items из формата Supabase в доменный тип
 */

import { DEFAULT_CURRENCY_CODE } from '@/config';
import type { WishlistItem, DbWishlistItem, GiftTag } from '../model';

/**
 * Маппинг строки wishlist_items из БД в доменный WishlistItem
 *
 * @param dbItem — строка из таблицы wishlist_items
 * @param wishlistId — ID родительского вишлиста
 */
export function mapDbItemToDomain(dbItem: DbWishlistItem, wishlistId: string): WishlistItem {
  return {
    id: dbItem.id,
    title: dbItem.title,
    description: dbItem.description || undefined,
    imageUrl: (dbItem.image_urls && dbItem.image_urls.length > 0) ? dbItem.image_urls[0] : undefined,
    imageUrls: (dbItem.image_urls && dbItem.image_urls.length > 0) ? dbItem.image_urls : undefined,
    link: dbItem.product_url || undefined,
    price: dbItem.price || undefined,
    currency: dbItem.currency || DEFAULT_CURRENCY_CODE,
    isPurchased: dbItem.is_purchased || false,
    purchasedBy: dbItem.purchased_by || undefined,
    giftTag: (dbItem.tags && dbItem.tags.length > 0) ? (dbItem.tags[0] as GiftTag) : undefined,
    category: dbItem.categories || undefined,
    purchaseLocation: dbItem.purchase_location || undefined,
    sourceItemId: dbItem.source_item_id || undefined,
    createdBy: dbItem.created_by || undefined,
    createdAt: dbItem.created_at || undefined,
    wishlistIds: [wishlistId],
  };
}